











































































































































































































































































































































































































































































































































































import CommentBox from '@/components/common/CommentBox.vue';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormInputPassword from '@/components/common/forms/FormInputPassword.vue';
import FormProbability from '@/components/common/forms/FormProbability.vue';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import BusinessYearSelect from '@/components/common/selects/BusinessYearSelect.vue';
import DeclinedReasonSelect from '@/components/common/selects/DeclinedReasonSelect.vue';
import PolicyStatusSelect from '@/components/common/selects/PolicyStatusSelect.vue';
import ProductSelect from '@/components/common/selects/ProductSelect.vue';
import TagSelect from '@/components/common/selects/TagSelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import UploadFiles from '@/components/common/UploadFiles.vue';
import BusinessYearFilter from '@/components/filters/BusinessYearFilter.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { CustomerApi } from '@/services/CustomerApi';
import { PolicyApi } from '@/services/PolicyApi';
import { TagApi } from '@/services/TagApi';
import CreateTaskModalLegacy from '@/views/pages/tasks/CreateTaskModal.vue';
import CreateTaskModalTasks2 from '@/views/pages/tasks2/CreateTaskModal.vue';
import PolicyEmbeddedTaskList from '@/components/tasks/PolicyEmbeddedTaskList.vue';
import EditTaskModalTasks2 from '@/views/pages/tasks2/EditTaskModal.vue';
import {
  ICustomerAutocompleteOption,
  ITag,
  ITask,
  PolicyModel,
  PolicyStatus,
  TagCategory,
} from 'admiral-core';
import _set from 'lodash.set';
import { mixins } from 'vue-class-component';
import { BookIcon, DownloadIcon, HelpCircleIcon, PlusIcon, TrashIcon } from 'vue-feather-icons';
import { Component, Prop } from 'vue-property-decorator';
import GoToFlixcheckCreateCheckButton from '@/components/integrations/flixcheck/GoToFlixcheckCreateCheckButton.vue';
import FlixcheckPolicyChecksOverview from '@/components/integrations/flixcheck/FlixcheckPolicyChecksOverview.vue';
@Component({
  computed: {
    PolicyStatus() {
      return PolicyStatus;
    },
  },
  components: {
    BusinessYearSelect,
    BusinessYearFilter,
    HelpCircleIcon,
    AdmiralCheckbox,
    FormDateInput,
    CreateTaskModalLegacy,
    CreateTaskModalTasks2,
    PolicyEmbeddedTaskList,
    EditTaskModalTasks2,
    FormTextarea,
    TagSelect,
    FormProbability,
    PolicyStatusSelect,
    ProductSelect,
    UserSelect,
    FormError,
    FormInputPassword,
    FormInput,
    FormRow,
    PlusIcon,
    BookIcon,
    DeclinedReasonSelect,
    UploadFiles,
    TrashIcon,
    DownloadIcon,
    CommentBox,
    GoToFlixcheckCreateCheckButton,
    FlixcheckPolicyChecksOverview,
  },
})
export default class PolicyForm extends mixins(PermissionMixin, BaseMixin, FormatMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: PolicyModel;

  @Prop({ required: true, type: Object })
  readonly errors!: keyof PolicyModel;

  tags: ITag[] = [];
  customerNames: string[] = [];
  crmCustomerOptions: ICustomerAutocompleteOption[] = [];
  policyTasks2SelectedTask: ITask | null = null;

  /** Antragsbuch-Bereich aufklappbar – standardmäßig zugeklappt. */
  antragsbuchExpanded = false;

  /** CRM-Kundenmodul aktiv → Namen aus customers-Tabelle. */
  get useCrmCustomers(): boolean {
    return this.hasAgencyPermission('customers');
  }

  get customerNameOptions(): string[] {
    if (this.useCrmCustomers) {
      return this.crmCustomerOptions.map((option) => option.name);
    }
    return this.customerNames;
  }

  /** Rechter Hinweis im Kundenfeld: Adresse (bekannter Kunde) oder „Neuer Kunde“. */
  get crmCustomerFieldHint(): 'address' | 'new' | null {
    if (!this.useCrmCustomers) {
      return null;
    }
    const input = this.value.customer?.trim();
    if (!input) {
      return null;
    }
    if (this.findCrmCustomerOption(input)) {
      return this.selectedCrmCustomerAddress ? 'address' : null;
    }
    return 'new';
  }

  /** Adresszeilen für einen exakt passenden CRM-Kunden. */
  get selectedCrmCustomerAddress(): { street?: string; cityLine?: string } | null {
    const input = this.value.customer?.trim();
    if (!input) {
      return null;
    }
    const match = this.findCrmCustomerOption(input);
    if (!match) {
      return null;
    }
    const cityLine = [match.zip, match.city].filter(Boolean).join(' ');
    if (!match.street && !cityLine) {
      return null;
    }
    return {
      street: match.street,
      cityLine: cityLine || undefined,
    };
  }

  findCrmCustomerOption(input: string): ICustomerAutocompleteOption | undefined {
    const normalized = this.normalizeCustomerName(input);
    return this.crmCustomerOptions.find(
      (option) => this.normalizeCustomerName(option.name) === normalized,
    );
  }

  normalizeCustomerName(name: string): string {
    return name.trim().toLowerCase().replace(/\s+/g, ' ');
  }

  async mounted() {
    this.$root.$emit('mounted-policy-form');
    await this.loadTags();
    await this.loadCustomers();
  }

  onInput(key: string, value: any) {
    const val = { ...this.value };

    _set(val, key, value);

    this.$emit('input', val);
  }

  onStatusUpdate(status: PolicyStatus) {
    this.onInput('status', status);
    this.$emit('policed-status-update');
  }

  canFlixcheck() {
    return this.hasAgencyPermission('flixcheck');
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get TAG_CATEGORY_POLCIES() {
    return TagCategory.Policies;
  }

  formatFileSize(size: number) {
    return (size / 1024).toFixed(0) + ' KB';
  }

  openPolicyTasks2Task(task: ITask) {
    this.policyTasks2SelectedTask = task;
    this.$nextTick(() => {
      (this.$refs.policyEditTaskModalTasks2 as any)?.$refs?.['edit-task']?.show();
    });
  }

  onPolicyTasks2TaskDelete(task: ITask) {
    this.deletedTask(task);
    this.policyTasks2SelectedTask = null;
  }

  deletedTask(task: ITask) {
    const tasks = this.value.tasks?.filter((t: ITask) => t.id !== task.id);
    this.onInput('tasks', tasks);
  }

  updatedTasks(task: ITask) {
    const tasks = [...(this.value.tasks || [])];
    for (let i = 0; i < tasks.length; i++) {
      if (this.value.tasks && tasks[i].id === task.id) {
        tasks[i] = task;
      }
    }
    this.onInput('tasks', [...tasks]);
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        category: TagCategory.Policies,
      });
      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  createdTask(task: ITask) {
    this.onInput('tasks', [...(this.value.tasks || []), task]);
  }

  get isModuleAntragsbuchActive() {
    return this.$store.state.DataModule.agency.moduleAntragsbuch;
  }

  /** Lädt Kundennamen für Autocomplete (Legacy: Policies, CRM: customers-Tabelle). */
  async loadCustomers() {
    try {
      if (this.useCrmCustomers) {
        const response = await CustomerApi.getDisplayNames({ agency: this.agency });
        this.crmCustomerOptions = response.data || [];
        return;
      }
      const response = await PolicyApi.getCustomerNames(this.agency);
      this.customerNames = response.data;
    } catch (e) {
      console.log(e);
    }
  }
}
